import { Chip } from "@heroui/react"
import { ArchiveBoxXMarkIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const ReadOnlyBadge = ({ 
  className = "", 
  isFullWidth = false, 
  size = "md" 
}) => (
  <Chip size={size} classNames={{ base: `${isFullWidth ? "w-full" : ""} max-w-none bg-blue-500 ${className}` }}>
    <span className={`flex items-center justify-center text-white px-2 font-semibold`}>
      <ArchiveBoxXMarkIcon className="w-5 h-5 mr-2 text-white" /> Read Only
    </span>
  </Chip>
)

ReadOnlyBadge.propTypes = {
  classNames: PropTypes.string,
  isFullWidth: PropTypes.bool,
  size: PropTypes.string,
}

export default ReadOnlyBadge
